import Swal from 'sweetalert2'

export const useConfirm =
    ({ icon = 'question', position = 'top-end', title = '', timer = 10000, text = '' }) =>
    async () => {
        const { isConfirmed } = await Swal.fire({
            icon,
            timer,
            position,
            title,
            text,
            showCancelButton: true,
            confirmButtonText: 'Yes, please!',
            cancelButtonText: 'No, cancel!',
        })

        return isConfirmed
    }
